var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-check-list pad"},[(_vm.checkList)?_c('check-list-form',{attrs:{"check-list":_vm.checkList},on:{"submitted":_vm.back}}):_vm._e(),(_vm.checkList === null)?_c('loading'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }